import { inject, Injectable } from '@angular/core';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import PolicyBalance from '../../../core/data/models/policy.balance.model';
import PaymentRequest from '../../../core/data/dtos/payment.request';
import { AuthService } from '../../auth/services/auth.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { LocalStoreService } from '../../../common/services/storage.service';
import keys from '../../../common/constants/keys';
import PoliciesBalance from '../../../core/data/models/policies.balance.model';
import PolicyInfo from '../../../core/data/models/policy.info.model';
import PaymentResponse from '../../../core/data/dtos/payment.response';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseCrudService<PolicyBalance> {
  policyInfos: PolicyInfo[] = [];
  controller = 'ePayment';
  private authService = inject(AuthService);
  private localStorageService = inject(LocalStoreService);

  private _openWithPolicy = new Subject<PoliciesBalance>();
  openWithPolicy$ = this._openWithPolicy.asObservable();

  constructor() {
    super();

    this.getBalance();
    this.authService._logout.subscribe(() => this.clearCart());
  }

  private _balance = new BehaviorSubject<PoliciesBalance[]>([]);

  balance$ = this._balance.asObservable();

  get balance() {
    return this._balance.value;
  }

  openWithPolicy(policy: PoliciesBalance) {
    this._openWithPolicy.next(policy);
  }

  clearCart() {
    this.policyInfos = [];
    this.clearStoredPolicies();
    this._balance.next([]);
  }

  async getBalance() {
    const idNumber = this.authService.user.idTokenClaims?.extension_IdNumber!;
    const result = await lastValueFrom(
      this.get<PolicyBalance>(
        undefined,
        `ClientDataAndPoliciesBalanceByIdNumber/${idNumber}`,
      ),
    );
    this._balance.next((result as unknown as PolicyBalance).policiesBalance);
    return result;
  }

  async getRate(currency: 'USD' = 'USD') {
    const result = await lastValueFrom(
      this.get<number>(undefined, `GetRate/${currency}`),
    );

    return result;
  }

  getStoredPolicies() {
    const policies = this.localStorageService.getItem(keys.checkout);
    return policies ? JSON.parse(policies) : undefined;
  }

  clearStoredPolicies() {
    this.localStorageService.setItem(keys.checkout, '');
  }

  doPayment(request: PaymentRequest) {
    return this.create(
      request,
      'ProcessPaymentByPolicy',
      {},
      false,
    ) as unknown as Observable<PaymentResponse>;
  }
}
